<mat-dialog-content class="mat-typography">
    {{data.terms}}
  </mat-dialog-content>

  <mat-dialog-actions align="center">
    <button mat-button mat-dialog-close>OK</button>
  </mat-dialog-actions>